<template>
  <div>
    <table class="table">
      <tr v-for="row in data.rows">
        <td v-for="field in row.fields">
          <component :is="'APPROVAL_' + field.fieldType" :data="field" :footnotes="footnotes"></component>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import APPROVAL_CHECKBOX
  from "./CHECKBOX.vue"
import APPROVAL_TEXT
  from "./TEXT.vue"
import APPROVAL_TEXTAREA
  from "./TEXTAREA.vue"
import APPROVAL_INPUT
  from "./INPUT.vue"
import APPROVAL_TOGGLE_GROUP
  from "./TOGGLE_GROUP.vue"

export default {
  name: 'TABLE',
  props: ['data', 'footnotes'],
  components: {
    APPROVAL_CHECKBOX,
    APPROVAL_TEXT,
    APPROVAL_TEXTAREA,
    APPROVAL_INPUT,
    APPROVAL_TOGGLE_GROUP,
  },
}
</script>



// WEBPACK FOOTER //
// TABLE.vue?3793fd15